import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { userLogoutAsync } from "../../../store/actions/authorize";

const Aside = () => {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const location = useLocation();

   const handleExit = async () => {
      const res = await dispatch(userLogoutAsync());
      res && navigate("/", { replace: true });
   };

   return (
      <aside className="aside">
         <nav className="aside__nav">
            <ul className="aside__nav-list">
               <li className="aside__nav-item">
                  <Link to="/profile"
                     className={location.pathname === "/profile" ? "aside__nav-link active" : "aside__nav-link"}
                  >
                     <img src="/img/accont.png" alt="account" />
                     <p className="aside__nav-title">حساب کاربری</p>
                  </Link>
               </li>

               <li className="aside__nav-item ">
                  <Link to="/orders"
                     className={location.pathname === "/orders" ? "aside__nav-link active" : "aside__nav-link"}
                  >
                     <img src="/img/orders.png" alt="orders" />
                     <p className="aside__nav-title">سفارشات </p>
                  </Link>
               </li>

               <li className="aside__nav-item ">
                  <Link to="/requests"
                     className={location.pathname === "/requests" ? "aside__nav-link active" : "aside__nav-link"}
                  >
                     <img src="/img/report-svgrepo-com.svg" alt="orders" style={{ width: "2.2em" }} />
                     <p className="aside__nav-title">درخواست‌ها </p>
                  </Link>
               </li>

               <li className="aside__nav-item" onClick={handleExit}>
                  <Link to="/" className="aside__nav-link" onClick={e => e.preventDefault()}>
                     <img src="/img/exit.png" alt="exit" />
                     <p className="aside__nav-title">خروج</p>
                  </Link>
               </li>
            </ul>
         </nav>
      </aside>
   );
};

export default Aside;
